import { generateHash } from '../../../utils/caching/common/key-generator';

import type {
	JiraIntentDetectionQueryVariables,
	SearchChatIntentDetectionQueryVariables,
} from './types';

/**
 * Helper function to create consistent cache keys.
 */
export const createCacheKey: (variables: JiraIntentDetectionQueryVariables) => string = (
	variables: JiraIntentDetectionQueryVariables,
): string => {
	const { siteId, orgId, query, experience, model, includePatternType } = variables;
	const parts = [siteId, orgId, query, experience];
	if (model) {
		parts.push(model);
	}
	parts.push(`includePatternType=${includePatternType}`);
	return parts.join(':');
};

/**
 * Creates a privacy-safe cache key for a Search/Chat intent request.
 *
 * The explicit tuple keeps the key stable regardless of object property order. Site, locale, and
 * model version remain structural scopes so hash collisions cannot cross those boundaries, while
 * hashing avoids retaining raw search input as part of the in-memory cache key.
 */
export const createSearchChatCacheKey = (
	variables: SearchChatIntentDetectionQueryVariables,
): string => {
	const { siteId, query, locale, modelVersion } = variables;
	const queryHash = generateHash(query).toString();

	return JSON.stringify(['search-chat-intent-detection', siteId, locale, modelVersion, queryHash]);
};
